var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// schemas/user/aid/aid.ts
import { z } from "zod";

// messages.ts
var MAX_DEFAULT = /* @__PURE__ */ __name((key, n) => `${key} must be at most ${n} characters`, "MAX_DEFAULT");

// validation.ts
var FIELD_LIMITS = {
  name: 30,
  email: 254,
  city: 60,
  schoolName: 80,
  zipCode: 8,
  relation: 50,
  disability: 200,
  referralExtra: 100,
  longText: 2e3,
  url: 2048,
  aidAmount: 6
};

// schemas/user/aid/aid.ts
var aidSchema = z.object({
  is_required_aid: z.boolean().optional().refine((v) => v === true || v === false, {
    message: "Please choose Yes or No"
  }),
  amount: z.string().max(FIELD_LIMITS.aidAmount, MAX_DEFAULT("Financial aid amount", FIELD_LIMITS.aidAmount)).nullable(),
  currency: z.string().nullable(),
  file_id: z.string().nullable(),
  is_terms_accepted: z.boolean().nullable()
}).superRefine((data, ctx) => {
  if (data.is_required_aid) {
    const amount = data.amount;
    if (!amount) {
      ctx.addIssue({ code: "custom", message: "The financial aid amount is required", path: ["amount"] });
    } else if (!/^\d+$/.test(amount)) {
      ctx.addIssue({ code: "custom", message: "Enter a valid amount (>= 100)", path: ["amount"] });
    } else {
      const v = Number(amount);
      if (!Number.isFinite(v) || v < 100) {
        ctx.addIssue({ code: "custom", message: "Enter a valid amount (>= 100)", path: ["amount"] });
      }
      if (v > 1e5) {
        ctx.addIssue({ code: "custom", message: "You are not eligible to apply for financial need support.", path: ["amount"] });
      }
    }
    if (!data.currency) {
      ctx.addIssue({ code: "custom", message: "Currency is required when is_required is true", path: ["currency"] });
    }
    if (data.is_terms_accepted !== true) {
      ctx.addIssue({ code: "custom", message: "Must be checked to continue", path: ["is_terms_accepted"] });
    }
    if (!data.file_id) {
      ctx.addIssue({ code: "custom", message: "File evidence is required when financial aid is required", path: ["file_id"] });
    }
  }
});
export {
  aidSchema
};
